import PropTypes from 'prop-types'

import { translate } from '@/utils/translations'

const Label = ({
  isSubscription,
  variant: { durationExpirationText, id, studentPrice }
}) => {

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control -- text content is provided at runtime via <Choose>/<When>/<Otherwise>, which static analysis can't detect
    <label
      htmlFor={id}
      id={`variant-${id}`}
    >
      <Choose>
        <When condition={isSubscription}>
          {translate('purchase.license_item')}
        </When>
        <Otherwise>
          {durationExpirationText}
          <div className='price'>{studentPrice}</div>
        </Otherwise>
      </Choose>
    </label>
  )
}

export default Label

Label.propTypes = {
  isSubscription: PropTypes.bool.isRequired,
  variant: PropTypes.shape({
    durationExpirationText: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    studentPrice: PropTypes.string.isRequired
  })
}
